"use-strict";
var CwLazyloadImg = (function () {
  return {
    init: function () {
      this.lazyReady();
    },
    lazyReady: function () {
      if (!!window.IntersectionObserver) {
        let observer = new IntersectionObserver(
          (entries, observer) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                const onImageLoad = (e) => {
                  const target = e.currentTarget;
                  setTimeout(() => {
                    target
                      ?.closest("motion-element")
                      ?.classList.remove("cw-loading-image");
                    target?.classList.remove("cw-loading-image");
                  }, 600);
                  e.currentTarget.removeEventListener("load", onImageLoad);
                };
                entry.target.width = entry.boundingClientRect.width;
                entry.target.height = entry.boundingClientRect.height;
                entry.target.sizes = `${entry.boundingClientRect.width}px`;
                entry.target.addEventListener("load", onImageLoad);
                observer.unobserve(entry.target);
              }
            });
          },
          { rootMargin: "10px" }
        );
        document.querySelectorAll(".cw-image-js img").forEach((img) => {
          observer.observe(img);
        });
      }
    },
  };
})();
CwLazyloadImg.init();
function CloseAllPopup(data) {
  publish("closeCanvas", data);
}

const imageReady = (imageOrArray) => {
  if (!imageOrArray) {
    return Promise.resolve();
  }
  imageOrArray =
    imageOrArray instanceof Element ? [imageOrArray] : Array.from(imageOrArray);
  return Promise.all(
    imageOrArray.map((image) => {
      return new Promise((resolve) => {
        if (
          (image.tagName === "IMG" && image.complete) ||
          !image.offsetParent
        ) {
          setTimeout(() => {
            image
              .closest("motion-element")
              ?.classList.remove("cw-loading-image");
            image.classList.remove("cw-loading-image");
            resolve();
          }, 100);
        } else {
          image.addEventListener("load", (e) => {
            e.currentTarget
              .closest("motion-element")
              ?.classList.remove("cw-loading-image");
            e.currentTarget.classList.remove("cw-loading-image");
            resolve();
          });
        }
      });
    })
  );
};

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}
class SlideSection extends HTMLElement {
  constructor() {
    super();
    this.globalSlide = null;
    this.init();
  }

  init() {
    if (document.body.classList.contains("index")) {
      let pos = window.pageYOffset;
      if (pos > 0 || document.body.classList.contains("swiper-lazy")) {
        this.initSlide();
      } else {
        if (this.classList.contains("lazy-loading-swiper-before")) {
          this.initSlide();
        } else {
          this.classList.add("lazy-loading-swiper-after");
        }
      }
    } else {
      this.initSlide();
    }
  }

  initSlide() {
    const _this = this;
    var autoplaying = _this?.dataset.autoplay === "true";
    const loop = _this?.dataset.loop === "true";
    const itemDesktop = _this?.dataset.desktop ? _this?.dataset.desktop : 4;
    var itemTablet = _this?.dataset.tablet ? _this?.dataset.tablet : "";
    const itemMobile = _this?.dataset.mobile ? _this?.dataset.mobile : 1;
    const direction = _this?.dataset.direction
      ? _this?.dataset.direction
      : "horizontal";
    var autoplaySpeed = _this?.dataset.autoplaySpeed
      ? _this?.dataset.autoplaySpeed * 1000
      : 3000;
    var speed = _this?.dataset.speed ? _this?.dataset.speed : 400;
    const effect = _this?.dataset.effect ? _this?.dataset.effect : "slide";
    const row = _this?.dataset.row ? _this?.dataset.row : 1;
    var spacing = _this?.dataset.spacing ? _this?.dataset.spacing : 30;
    const progressbar = _this?.dataset.paginationProgressbar === "true";
    const autoItem = _this?.dataset.itemMobile === "true";
    const autoHeight = _this?.dataset.autoHeight === "true";
    const paginationCustom = _this?.dataset.customPagination;
    const slideShow = _this?.dataset.slideshow === "true";
    const revealSlideshow = _this?.dataset.revealSlideshow === "true";
    const customNavigation = _this?.dataset.customNavigation === "true";
    const customPrev = _this?.dataset.customPrev;
    const customNext = _this?.dataset.customNext;
    const arrowCenterimage = _this?.dataset.arrowCenterimage
      ? _this?.dataset.arrowCenterimage
      : 0;
    spacing = Number(spacing);
    autoplaySpeed = Number(autoplaySpeed);
    speed = Number(speed);
    if (autoplaying) {
      autoplaying = { delay: autoplaySpeed };
    }
    if (!itemTablet) {
      if (itemDesktop < 2) {
        itemTablet = 1;
      } else if (itemDesktop < 3) {
        itemTablet = 2;
      } else {
        itemTablet = 3;
      }
    }
    if (direction == "vertical") {
      _this.style.maxHeight = _this.offsetHeight + "px";
    }
    this.globalSlide = new Swiper(_this, {
      slidesPerView: autoItem ? "auto" : itemMobile,
      spaceBetween: spacing >= 15 ? 15 : spacing,
      autoplay: autoplaying,
      direction: direction,
      loop: loop,
      effect: effect,
      autoHeight: autoHeight,
      speed: speed,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      centeredSlides: false,
      grabCursor: true,
      grid: {
        rows: row,
        fill: "row",
      },
      navigation: {
        nextEl: customNavigation ? document.querySelector(`.${customNext}`) : _this.querySelector(".swiper-button-next"),
        prevEl: customNavigation ? document.querySelector(`.${customPrev}`) : _this.querySelector(".swiper-button-prev"),
      },
      pagination: {
        clickable: true,
        el: paginationCustom == undefined ? 
          _this.querySelector(".parent-pagination") ||
          _this.querySelector(".swiper-pagination") : _this.querySelector(`.${paginationCustom}`),
        type: progressbar ? "progressbar" : "bullets",
      },
      breakpoints: {
        768: {
          slidesPerView: itemTablet,
          spaceBetween: spacing >= 30 ? 30 : spacing,
          type: progressbar ? "progressbar" : "bullets",
          autoHeight: false,
          centeredSlides: false
        },
        1025: {
          slidesPerView: itemDesktop,
          spaceBetween: spacing,
          type: progressbar ? "progressbar" : "bullets",
          autoHeight: false,
          centeredSlides: slideShow && itemDesktop == 1.5 ? true : false,
        },
      },
      thumbs: {
        swiper: this.thumbnailSlide ? this.thumbnailSlide : null,
      },

      on: {
        init: function (e) {
          var sec__tiktok = _this.closest(".sec__tiktok-video");
          e.autoplay.stop();
          if (_this?.dataset.autoplay === "true") {
            Motion.inView(
              _this,
              async () => {
                e.autoplay.start();
              },
              { margin: "0px 0px -50px 0px" }
            );
          }

          if (sec__tiktok) {
            _this.initSecTiktok(sec__tiktok);
            window.addEventListener("resize", function () {
              setTimeout(() => {
                _this.initSecTiktok(sec__tiktok);
              }, 150);
            });
          }
          if (arrowCenterimage) {
            var items_slide = _this.querySelectorAll(
              ".product-item__media--ratio"
            );
            if (items_slide.length != 0) {
              var oH = [];
              items_slide.forEach((e) => {
                oH.push(e.offsetHeight / 2);
              });
              var max = Math.max(...oH);
              var arrowsOffset = "--arrows-offset-top: " + max + "px";
              if (_this.querySelectorAll(".swiper-arrow")) {
                _this.querySelectorAll(".swiper-arrow").forEach((arrow) => {
                  arrow.setAttribute("style", arrowsOffset);
                });
              }
            }
          }
          var video = _this.querySelector("video.slideshow");
          if (video) {
            const handleIntersection = (entries, observer) => {
              if (!entries[0].isIntersecting) return;
              observer.unobserve(_this);
              const videos = _this.querySelectorAll("video");
              videos.forEach((video) => {
                const dataSrc = video.dataset.src;
                if (dataSrc) {
                  video.src = dataSrc;
                  video.removeAttribute("data-src");
                }
              });
            };
            new IntersectionObserver(handleIntersection.bind(_this), {
              rootMargin: "0px 0px 200px 0px",
            }).observe(_this);
          }
        },
        slideChange: function () {
          const index_currentSlide = this.realIndex + 1;
          if (_this.closest(".sec__testimonials-single")) {
            const allDots = _this
              .closest(".sec__testimonials-single")
              .querySelectorAll(`single-item`);
            allDots.forEach((dot) => {
              dot.classList.remove("active");
            });
            _this
              .closest(".sec__testimonials-single")
              .querySelector(
                ".testimonials-author-image[data-position='" +
                  index_currentSlide +
                  "']"
              )
              .classList.add("active");
          }
        },
        slideChangeTransitionStart: function () {
          if (!slideShow) return;
          const currentSlide = this.slides[this.activeIndex];
          currentSlide
            .querySelectorAll("motion-element")
            .forEach(async (motion) => {
              await motion.preInitialize();
            });
        },
        slideChangeTransitionEnd: function () {
          if (!slideShow) return;
          const currentSlide = this.slides[this.activeIndex];
          currentSlide
            .querySelectorAll("motion-element")
            .forEach(async (motion) => {
                motion.classList.remove("animate-delay"),
                await motion.initialize();
            });
        },
        afterInit: function () {
          if (slideShow && revealSlideshow && itemDesktop <= 3) {
            _this.duplicateSlides(this);
          }
        },
        touchMove: function (swiper, event) {
          const innerWidth = event.view.innerWidth;
          const swiperMedia = swiper.el.classList.contains('swiper-popup-media');
          const slidePopup = document.querySelector("slide-section-popup");
          if (slidePopup && swiperMedia && innerWidth > 767) {
            slidePopup.swiper.allowTouchMove = false;
            slidePopup.swiper.unsetGrabCursor();
          }
        },
        touchEnd: function (swiper, event) {
          const innerWidth = event.view.innerWidth;
          const swiperMedia = swiper.el.classList.contains('swiper-popup-media');
          const slidePopup = document.querySelector("slide-section-popup");
          if (!swiperMedia) return;
          if (slidePopup && innerWidth > 767) {
            slidePopup.swiper.allowTouchMove = true;
            slidePopup.swiper.setGrabCursor();
          }
        }
      },
    });
  }

  duplicateSlides(swiper) {
    const _this = this;
    const swiperWrapper = _this.querySelector('.swiper-wrapper');
    const originalSlides = swiperWrapper.querySelectorAll('.swiper-slide');
    const paginationEl = _this.querySelector('.swiper-pagination');
    
    if (paginationEl) {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList') {
            mutation.addedNodes.forEach((node) => {
              if (node.nodeType === 1 && node.classList.contains('swiper-pagination-bullet')) {
                const allBullets = paginationEl.querySelectorAll('.swiper-pagination-bullet');
                const bulletIndex = Array.from(allBullets).indexOf(node);
                if (bulletIndex >= originalSlides.length) {
                  node.classList.add('swiper-pagination-duplicate');
                }
              }
            });
          }
        });
        observer.disconnect();
      });
      
      observer.observe(paginationEl, { childList: true });
    }
    
    originalSlides.forEach((slide) => {
        const clonedSlide = slide.cloneNode(true);
        clonedSlide.classList.add('swiper-slide-duplicate');
        swiperWrapper.appendChild(clonedSlide);
    });
    
    swiper.update();
  }

  initSecTiktok(sec) {
    sec.querySelectorAll(".swiper-slide").forEach((arrow) => {
      const tiktok = arrow.querySelector(".section_tiktok-image");
      let width = "--item-width: " + arrow.offsetWidth;
      tiktok.setAttribute("style", width);
    });
  }
}
// <slide-section> is also registered in theme-components.js, but we keep a guard here so
// carousels still work when the bundle is missing or fails to load.
if (!customElements.get("slide-section")) {
  customElements.define("slide-section", SlideSection);
}

class PopupBase extends HTMLElement {
  constructor() {
    super();
    this.customClass = this.dataset.customClass;
    this.modal = null;
  }

  initPopup(content, text, customClass, modalWidth) {
    const _this = this;
    this.modal = new tingle.modal({
      footer: false,
      stickyFooter: false,
      closeMethods: ["overlay", "button", "escape"],
      cssClass: [this.customClass || customClass],
      onOpen: function () {
        const modalBoxContent = this.modal.querySelector(".tingle-modal-box");
        if (modalWidth) {
          modalBoxContent.style.setProperty("--popup-max-width", modalWidth);
        }
        document.dispatchEvent(new CustomEvent("modal:opened"));
        document.documentElement.classList.add("open-popup");
        root.style.setProperty(
          "padding-right",
          getScrollBarWidth.init() + "px"
        );
        const video = this.modalBox.querySelector("video");
        if (!video) return;
        video.play();
        if (this.modal.classList.contains("shopable-video")) {
          video.muted = false;
        }
      },
      onClose: function () {
        document.dispatchEvent(new CustomEvent("modal:closed"));
        document.documentElement.classList.remove("open-popup");
        root.style.removeProperty("padding-right");
      },
      beforeClose: function () {
        _this.onCloseEvent();
        document.documentElement.classList.remove("open-popup");
        root.style.removeProperty("padding-right");
        return true;
      },
    });
    this.modal.setHeader = function (content) {
      let popup_content = this.modalBoxContent;
      let popup_header = document.createElement("div");
      popup_header.classList.add("tingle-modal-box__header");
      popup_header.innerHTML = content;
      let parentElement = popup_content.parentNode;
      parentElement.insertBefore(popup_header, popup_content);
    };
    if (text) {
      this.modal.setHeader(text);
    }

    this.modal.setContent(content);
    this.modal.open();
  }

  onClose() {
    this.modal.close();
  }
  onCloseEvent() {}
}

class SwatchInit extends HTMLElement {
  constructor() {
    super();
    this.options = null;
    this.init();
  }

  init() {
    const _this = this;
    this.querySelectorAll(".product__color-swatches--js").forEach((btn) => {
      _this.checkSwatches(btn);
    });
  }
  checkSwatches(e) {
    const { color, image, customValue, swatchType, optionSwatchValue } =
      e.dataset;
    if (color) {
      if (swatchType != "variant_images") {
        if (optionSwatchValue.length == 0 || optionSwatchValue == null) {
          if (this.checkColor(color)) {
            e.style.backgroundColor = color;
            e.classList.add(customValue);
          } else {
            e.classList.add(customValue);
            if (image) {
              e.classList.add("color__" + color.replace(" ", "-"));
              e.style.backgroundColor = null;
              e.style.backgroundImage = "url('" + image + "')";
              e.style.backgroundSize = "cover";
              e.style.backgroundRepeat = "no-repeat";
            }
          }
        } else {
          e.style.setProperty("--swatch--background", optionSwatchValue);
        }
      } else {
        if (optionSwatchValue == null || optionSwatchValue.length == 0) {
          if (image) {
            e.classList.add("color__" + color.replace(" ", "-"));
            e.style.backgroundColor = null;
            e.style.backgroundImage = "url('" + image + "')";
            e.style.backgroundSize = "cover";
            e.style.backgroundRepeat = "no-repeat";
          } else if (this.checkColor(color)) {
            e.style.backgroundColor = color;
            e.classList.add(customValue);
          } else {
            e.classList.add(customValue);
          }
        } else {
          e.style.setProperty("--swatch--background", optionSwatchValue);
        }
      }
    }
  }
  checkColor(strColor) {
    var s = new Option().style;
    s.color = strColor;
    return s.color == strColor;
  }
  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll(".product__color-swatches--js.active"),
      (select) => select.getAttribute("data-value")
    );
    this.variantData.find((variant) => {
      if (this.options.length == 1) {
        const variantOptions = {
          1: variant.option1,
          2: variant.option2,
          3: variant.option3,
        };
        if (variantOptions[this.position_swatch] === this.options[0]) {
          this.options = variant.options;
        }
      }
    });
  }
  updateMasterId(variantData) {
    return (this.currentVariant = variantData.find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    }));
  }
}

// js for 3d product - not done yet
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        deferredElement.play();
      }
    }
  }
}

function handleErrorMessagePopup(errorMessage = false) {
  const url = `${window.location.pathname}?section_id=form-message`;
  fetch(url)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, "text/html");
      const elementErrorMessage = html.querySelector(
        ".product-form__error-message-wrapper"
      );
      const elementMessage = elementErrorMessage.querySelector(
        ".product-form__error-message"
      );
      elementMessage.textContent = errorMessage;
      showToast(elementErrorMessage.innerHTML, 5000, "modal-error");
    })
    .catch((e) => {
      throw e;
    });
}

function showToast(message, duration = 3000, customClass = "") {
  let toastContainer = document.getElementById("toast-container");
  if (!toastContainer) {
    toastContainer = document.createElement("div");
    toastContainer.id = "toast-container";
    document.body.appendChild(toastContainer);
  }

  const toast = document.createElement("div");
  toast.className = `toast show ${customClass}`;
  toast.innerHTML = message;
  toastContainer.appendChild(toast);

  Motion.animate(
    toast,
    {
      opacity: [0, 1],
      scale: [0.3, 1],
    },
    {
      duration: 0.3,
      easing: "ease-out",
    }
  );

  setTimeout(() => {
    closeToast(toast);
  }, duration);
}

function closeToast(toast) {
  Motion.animate(
    toast,
    { opacity: 0, scale: 0.5 },
    { duration: 0.2, easing: "ease-in" }
  ).then(() => {
    toast.remove();
  });
}

/**
 * SlideLazyLoad — 用户首次交互后再初始化 Swiper 轮播和评论组件
 *
 * 工作流程：
 * 1. 页面加载后监听用户交互事件（键盘、鼠标、触摸、滚轮）
 * 2. 首次交互时移除监听器，触发懒加载逻辑
 * 3. 激活所有 .lazy-loading-swiper-after 的轮播
 * 4. 激活所有 .review-product-added 的评论区块
 * 5. 依次执行延迟脚本队列（normal → defer → async）
 * 6. 补发 DOMContentLoaded / load 兼容事件，兼容第三方库
 */
class SlideLazyLoad {
  constructor(triggerEvents) {
    this.triggerEvents = triggerEvents
    this.listenerOptions = { passive: true }
    this.onUserInteraction = this.onFirstInteraction.bind(this)
    this.scriptQueues = { normal: [], async: [], defer: [] }
  }

  /**
   * 首次用户交互回调：移除所有交互监听器，然后执行加载逻辑
   * 若 DOM 尚未解析完成则等待 DOMContentLoaded 再执行
   */
  onFirstInteraction() {
    this.removeInteractionListeners()
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", this.loadAll.bind(this))
    } else {
      this.loadAll()
    }
  }

  removeInteractionListeners() {
    this.triggerEvents.forEach((eventName) => {
      window.removeEventListener(eventName, this.onUserInteraction, this.listenerOptions)
    })
  }

  addInteractionListeners() {
    this.triggerEvents.forEach((eventName) => {
      window.addEventListener(eventName, this.onUserInteraction, this.listenerOptions)
    })
  }

  /**
   * 激活首屏之外被延迟的 Swiper 和评论组件
   */
  activateLazyComponents() {
    document.body.classList.add("swiper-lazy", "review-lazy")

    // 初始化等待首次交互后才渲染的 Swiper 轮播
    document.querySelectorAll(".lazy-loading-swiper-after").forEach((el) => {
      el.classList.remove("lazy-loading-swiper-after")
      this.initSlide(el)
    })

    // 将评论 JSON 内容替换为真实 HTML，移除加载状态
    document.querySelectorAll(".review-product-added").forEach((el) => {
      const reviewJson = el.querySelector(".product-review-json")
      if (reviewJson) {
        el.innerHTML = reviewJson.innerHTML
      }
      el.classList.remove("review-product-added", "inline-loading")
    })
  }

  /**
   * 为懒加载触发的 slide-section 元素初始化 Swiper
   * 与 SlideSection.initSlide() 共享相同的 data-* 配置协议，
   * 但此处为独立调用（el 不是 Web Component 实例，而是 DOM 节点）
   */
  initSlide(el) {
    const autoplay = el.dataset.autoplay === "true"
    const loop = el.dataset.loop === "true"
    const itemDesktop = Number(el.dataset.desktop || 4)
    const itemMobile = Number(el.dataset.mobile || 1)
    const direction = el.dataset.direction || "horizontal"
    const effect = el.dataset.effect || "slide"
    const row = Number(el.dataset.row || 1)
    const progressbar = el.dataset.paginationProgressbar === "true"
    const autoItem = el.dataset.itemMobile === "true"
    const arrowCenterImage = Number(el.dataset.arrowCenterimage || 0)

    const autoplaySpeed = Number(el.dataset.autoplaySpeed || 3) * 1000
    const speed = Number(el.dataset.speed || 400)
    const spacing = Number(el.dataset.spacing || 30)

    // 根据桌面列数自动推断平板列数
    let itemTablet = Number(el.dataset.tablet) || 0
    if (!itemTablet) {
      if (itemDesktop < 2) itemTablet = 1
      else if (itemDesktop < 3) itemTablet = 2
      else itemTablet = 3
    }

    if (direction === "vertical") {
      el.style.maxHeight = el.offsetHeight + "px"
    }

    el.globalSlide = new Swiper(el, {
      slidesPerView: autoItem ? "auto" : itemMobile,
      spaceBetween: Math.min(spacing, 15),
      autoplay: autoplay ? { delay: autoplaySpeed } : false,
      direction: direction,
      loop: loop,
      effect: effect,
      speed: speed,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      grid: {
        rows: row,
        fill: "row",
      },
      navigation: {
        nextEl: el.querySelector(".swiper-button-next"),
        prevEl: el.querySelector(".swiper-button-prev"),
      },
      pagination: {
        clickable: true,
        el: el.querySelector(".parent-pagination") || el.querySelector(".swiper-pagination"),
        type: progressbar ? "progressbar" : "bullets",
      },
      breakpoints: {
        768: {
          slidesPerView: itemTablet,
          spaceBetween: Math.min(spacing, 30),
          pagination: { type: progressbar ? "progressbar" : "bullets" },
        },
        1025: {
          slidesPerView: itemDesktop,
          spaceBetween: spacing,
          pagination: { type: progressbar ? "progressbar" : "bullets" },
        },
      },
      on: {
        init(swiper) {
          // 进入视口后才启动自动播放，避免后台 Tab 浪费资源
          swiper.autoplay.stop()
          if (el.dataset.autoplay === "true") {
            Motion.inView(
              el,
              async () => { swiper.autoplay.start() },
              { margin: "0px 0px -50px 0px" }
            )
          }

          // TikTok 视频区块：同步每个 slide 宽度到 CSS 变量
          const tiktokSection = el.closest(".sec__tiktok-video")
          if (tiktokSection) {
            syncTiktokSlideWidths(el, tiktokSection)
            window.addEventListener("resize", () => {
              setTimeout(() => syncTiktokSlideWidths(el, tiktokSection), 150)
            })
          }

          // 将导航箭头垂直中心对齐到商品图片中线
          if (arrowCenterImage) {
            const mediaItems = el.querySelectorAll(".product-item__media--ratio")
            if (mediaItems.length > 0) {
              const maxHalfHeight = Math.max(...Array.from(mediaItems).map((m) => m.offsetHeight / 2))
              el.querySelectorAll(".swiper-arrow").forEach((arrow) => {
                arrow.style.setProperty("--arrows-offset-top", maxHalfHeight + "px")
              })
            }
          }
        },

        // 切换 slide 时为不可见的 motion-element 设置 hold 标记，避免重复播放动画
        realIndexChange() {
          el.querySelectorAll(".swiper-slide motion-element:not([data-image])").forEach((motion) => {
            if (!motion.hasAttribute("hold")) {
              motion.setAttribute("hold", true)
            }
          })
        },

        // 单图轮播（.sec__testimonials-single）：联动作者头像高亮
        slideChange() {
          const testimonialSection = el.closest(".sec__testimonials-single")
          if (!testimonialSection) return
          const currentIndex = this.realIndex + 1
          testimonialSection.querySelectorAll("single-item").forEach((dot) => {
            dot.classList.remove("active")
          })
          testimonialSection
            .querySelector(`.testimonials-author-image[data-position='${currentIndex}']`)
            ?.classList.add("active")
        },
      },
    })
  }

  /**
   * 主流程：激活组件 → 执行脚本队列 → 补发生命周期事件
   */
  async loadAll() {
    this.activateLazyComponents()
    await this.drainScriptQueue(this.scriptQueues.normal)
    await this.drainScriptQueue(this.scriptQueues.defer)
    await this.drainScriptQueue(this.scriptQueues.async)
    await this.fireDOMContentLoaded()
    await this.fireWindowLoad()
    window.dispatchEvent(new Event("clawerspeed-allScriptsLoaded"))
  }

  /**
   * 顺序清空脚本队列，每个脚本加载完成后才执行下一个
   */
  async drainScriptQueue(queue) {
    const script = queue.shift()
    if (!script) return
    await this.activateScript(script)
    await this.drainScriptQueue(queue)
  }

  /**
   * 将 <script> 节点替换为新节点以强制浏览器执行它
   *
   * Shopify Speed 优化场景中，延迟脚本会将 type="text/javascript"
   * 改写为自定义 type（阻止执行），并通过 data-clawerlazy-type
   * 保存原始 type 值，此处在加载时还原。
   */
  async activateScript(originalScript) {
    await this.nextFrame()
    return new Promise((resolve) => {
      const newScript = document.createElement("script")

      Array.from(originalScript.attributes).forEach((attr) => {
        let attrName = attr.nodeName
        // 跳过被替换的 type，使用 data-clawerlazy-type 中保存的原始值
        if (attrName === "type") return
        if (attrName === "data-clawerlazy-type") {
          attrName = "type"
        }
        newScript.setAttribute(attrName, attr.nodeValue)
      })

      if (originalScript.hasAttribute("src")) {
        // 外部脚本：等待 load 或 error 后 resolve
        newScript.addEventListener("load", resolve)
        newScript.addEventListener("error", resolve)
      } else {
        // 内联脚本：同步执行，直接 resolve
        newScript.text = originalScript.text
        resolve()
      }

      originalScript.parentNode.replaceChild(newScript, originalScript)
    })
  }

  /**
   * 补发 DOMContentLoaded 相关事件，兼容在首次交互后才注册监听器的第三方库
   */
  async fireDOMContentLoaded() {
    this.domReadyFired = true
    await this.nextFrame()
    document.dispatchEvent(new Event("clawerspeed-DOMContentLoaded"))
    await this.nextFrame()
    window.dispatchEvent(new Event("clawerspeed-DOMContentLoaded"))
    await this.nextFrame()
    document.dispatchEvent(new Event("clawerspeed-readystatechange"))
    await this.nextFrame()
    document.claweronreadystatechange?.()
  }

  /**
   * 补发 window load / pageshow 事件，兼容依赖这些事件的第三方库
   */
  async fireWindowLoad() {
    await this.nextFrame()
    window.dispatchEvent(new Event("clawerspeed-load"))
    await this.nextFrame()
    window.claweronload?.()
    await this.nextFrame()
    window.dispatchEvent(new Event("clawerspeed-pageshow"))
    await this.nextFrame()
    window.claweronpageshow?.()
  }

  /**
   * 等待下一个动画帧，避免长任务阻塞主线程
   */
  nextFrame() {
    return new Promise((resolve) => requestAnimationFrame(resolve))
  }

  static run() {
    const loader = new SlideLazyLoad([
      "keydown",
      "mousemove",
      "touchmove",
      "touchstart",
      "touchend",
      "wheel",
    ])
    loader.addInteractionListeners()
  }
}

/**
 * TikTok 视频区块辅助函数：将每个 slide 宽度同步到 CSS 变量
 * 抽离为独立函数以避免重复定义
 */
function syncTiktokSlideWidths(swiperEl, tiktokSection) {
  tiktokSection.querySelectorAll(".swiper-slide").forEach((slide) => {
    const tiktokImage = slide.querySelector(".section_tiktok-image")
    if (tiktokImage) {
      tiktokImage.style.setProperty("--item-width", slide.offsetWidth)
    }
  })
}

SlideLazyLoad.run();

// <copy-button> (incl. updateUrl) is now defined in theme-components.js (src/components/ui/copy-button.ts).

/* =========================================================
   Button Ripple Effect (水波浪点击动画)
   Uses event delegation — no re-init needed for dynamic buttons.
   ========================================================= */
(function initButtonRipple() {
  const BTN_SELECTOR = [
    '.btn-primary',
    '.btn-outline',
    '.btn',
    '.btn-white',
    'body .shopify-payment-button__more-options',
    'body .shopify-payment-button__button--unbranded',
    '.dmp_discount-form button'
  ].join(',')

  // Yield until the browser has committed the next frame, then run on a fresh
  // task. Work scheduled here is no longer part of the interaction's INP.
  function afterNextPaint(fn) {
    requestAnimationFrame(function () {
      setTimeout(fn, 0)
    })
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest(BTN_SELECTOR)

    if (
      !btn ||
      btn.disabled ||
      btn.classList.contains('btn-reset') ||
      btn.classList.contains('btn-link') ||
      btn.getAttribute('aria-disabled') === 'true'
    ) return

    // The ripple is purely decorative, so none of it may run inside the click
    // handler: getBoundingClientRect() forces a synchronous layout and appending
    // the ripple triggers style/layout/paint, both of which land straight in the
    // INP measurement window. rAF -> setTimeout defers all of it until after the
    // browser has painted the frame that responds to this click.
    const clientX = e.clientX
    const clientY = e.clientY

    afterNextPaint(function () {
      if (!btn.isConnected) return

      const rect = btn.getBoundingClientRect()
      // Diameter = 2× the longest diagonal so ripple always covers full button
      const diameter = Math.hypot(rect.width, rect.height) * 2.2
      const x = clientX - rect.left
      const y = clientY - rect.top

      const ripple = document.createElement('span')
      ripple.className = 'btn-ripple'
      ripple.style.cssText = [
        'width:' + diameter + 'px',
        'height:' + diameter + 'px',
        'left:' + x + 'px',
        'top:' + y + 'px'
      ].join(';')

      btn.appendChild(ripple)

      // animationend never fires when the ripple ends up display:none
      // (button[disabled]/.disabled), so keep a fallback or they pile up in the
      // DOM and make every later interaction more expensive.
      const cleanup = function () {
        clearTimeout(fallback)
        ripple.remove()
      }
      const fallback = setTimeout(cleanup, 1000)
      ripple.addEventListener('animationend', cleanup, { once: true })
    })
  })
})();

/**
 * Fix: theme-components.js ProductForm only re-enables the submit button in the
 * success path (.finally on the inner section-render chain). When Shopify's
 * /cart/add returns a non-2xx status (e.g. 422 "already sold out"), the handler
 * returns early without removing aria-disabled or the loading class, so every
 * subsequent click is silently swallowed by the aria-disabled guard.
 *
 * We watch for the inline error wrapper becoming visible and immediately
 * re-enable the button so the shopper can try again (or see the Sold Out state
 * if the variant selector has updated availability in the meantime).
 */
;(function () {
  function attachWatcher(wrapper) {
    if (wrapper._adsErrWatcher) return
    wrapper._adsErrWatcher = true
    var obs = new MutationObserver(function () {
      if (wrapper.hasAttribute("hidden")) return
      var productForm = wrapper.parentNode
      while (productForm && productForm.tagName && productForm.tagName.toLowerCase() !== "product-form") {
        productForm = productForm.parentNode
      }
      if (!productForm) return
      var btn = productForm.querySelector('[type="submit"][name="add"]')
      if (!btn) return
      if (btn.getAttribute("aria-disabled") === "true") {
        btn.removeAttribute("aria-disabled")
        btn.classList.remove("loading")
      }
    })
    obs.observe(wrapper, { attributes: true, attributeFilter: ["hidden"] })
  }

  function scanAndAttach() {
    var wrappers = document.querySelectorAll(".product-form__error-message-wrapper")
    for (var i = 0; i < wrappers.length; i++) {
      attachWatcher(wrappers[i])
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scanAndAttach)
  } else {
    scanAndAttach()
  }

  // Also handle dynamically injected product forms (quickview, etc.)
  var bodyObs = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var nodes = mutations[i].addedNodes
      for (var j = 0; j < nodes.length; j++) {
        var node = nodes[j]
        if (node.nodeType !== 1) continue
        var found = node.classList && node.classList.contains("product-form__error-message-wrapper")
          ? [node]
          : node.querySelectorAll ? node.querySelectorAll(".product-form__error-message-wrapper") : []
        for (var k = 0; k < found.length; k++) {
          attachWatcher(found[k])
        }
      }
    }
  })
  bodyObs.observe(document.body || document.documentElement, { childList: true, subtree: true })
})();
